import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PatchOrganisationBoardRequestType,
  PatchOrganisationBoardResponseType,
} from '../types';

export const patchOrganisationBoard = async ({
  pathParams: { organisationId, boardId },
  body,
}: PatchOrganisationBoardRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}`;
  const { data } =
    await apiAuthClient.patch<PatchOrganisationBoardResponseType>(url, body);
  return data.data;
};
